import * as _ from "lodash";

export function objectComparisonFunction(option: any, value: any): boolean {
  return (
    _.isEqual(option, value) ||
    _.isEqual(option?.id, value) ||
    (!_.isUndefined(option?.id) && !_.isUndefined(value?.id) && _.isEqual(option?.id, value?.id))
  );
}
